import React from 'react';
import classNames from 'classnames';
import { useLocation } from 'react-router-dom';
import { IconLeftArrow, IconRightArrow, NamedLink } from '../../../components';
import Carousel from 'react-multi-carousel';
import { filterSliderResponsive } from '../../../config/marketplace-custom-config';

import css from './QuickFilters.module.css';
import './Carousel/React-Multi-Carousel.css';

const ButtonGroup = ({ next, previous, goToSlide, ...rest }) => {
  return (
    <div className="carousel-button-group">
      <div className={classNames(css.sliderControls, css.leftArrow)} onClick={previous}>
        <IconLeftArrow />
      </div>
      <div className={classNames(css.sliderControls, css.rightArrow)} onClick={next}>
        <IconRightArrow />
      </div>
    </div>
  );
};

function QuickFilters(props) {
  const { filters, viewport, onFilter, username, author } = props;

  const isMobileLayout = viewport.width > 0 && viewport.width < 768;
  const location = useLocation();
  const activeIndex = location && location.state && location.state.activeIndex;

  const filterContent =
    filters &&
    filters.map((item, i) => {
      return (
        <NamedLink
          name="StorePage"
          params={username ? { username: username || author?.id?.uuid } : { id: author?.id?.uuid }}
          to={{ search: item.search, state: { id: author?.id?.uuid } }}
          className={classNames(css.link, {
            [css.active]: activeIndex == i,
          })}
          key={i}
        >
          <div
            className={css.quickFilter}
            onClick={() => onFilter(item && item.name && item.name.toLowerCase(), i)}
          >
            {item?.icon}
            <span>{item?.name}</span>
          </div>
        </NamedLink>
      );
    });

  return (
    <div className={css.filters}>
      {!isMobileLayout ? (
        <Carousel
          additionalTransfrom={0}
          arrows={false}
          autoPlaySpeed={3000}
          centerMode={false}
          className={css.itemSlider}
          containerClass={css.sliderContainer}
          dotListClass={css.sliderDots}
          draggable
          focusOnSelect={false}
          customButtonGroup={<ButtonGroup />}
          infinite={true}
          itemClass={css.sliderItem}
          keyBoardControl
          minimumTouchDrag={80}
          pauseOnHover
          renderArrowsWhenDisabled={false}
          renderButtonGroupOutside={false}
          renderDotsOutside={false}
          responsive={filterSliderResponsive}
          rewind={false}
          rewindWithAnimation={false}
          rtl={false}
          shouldResetAutoplay
          showDots={false}
          sliderClass=""
          slidesToSlide={1}
          swipeable
        >
          {filterContent}
        </Carousel>
      ) : (
        <div className={css.mobileFilterCategories}> {filterContent}</div>
      )}
    </div>
  );
}

export default QuickFilters;
